import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { MediaHits, type MediaHitsQuery, type MediaHitsQueryVariables } from './index.graphql';

const EMPTY_MEDIA_HITS: NonNullable<MediaHitsQuery['mediaHitsPage']> = {
	isLastPage: true,
	numberOfStarterMedia: 0,
	mediaHits: [],
};

export async function fetchMediaHits(petitionId: string, { gql: { fetch } }: UtilityContext) {
	try {
		const { data } = await fetch<NonNullable<MediaHitsQuery>, MediaHitsQueryVariables>({
			query: MediaHits,
			variables: {
				petitionId,
				pageOffset: 0,
				pageSize: 5,
			},
			batched: false,
			rejectOnError: true,
		});

		return data?.mediaHitsPage || EMPTY_MEDIA_HITS;
	} catch (error) {
		return EMPTY_MEDIA_HITS;
	}
}
